export function renderTitle(root: HTMLElement, onStart: () => void) {
  root.innerHTML = `
    <div class="title-screen">
      <canvas id="title-particles" style="position:absolute;inset:0;pointer-events:none;z-index:0;"></canvas>
      <div class="title-logo">BATTLE BRAWL</div>
      <div class="title-sub">Pokémon × Plants × Zombies</div>
      <button class="btn-primary" id="start-btn">NEW BATTLE</button>
      <div style="margin-top: 28px; color: var(--muted); font-size: 13px; font-weight: 500; letter-spacing: 0.5px; position: relative; z-index: 1;">
        Build two teams. Watch them fight. Cast spells to turn the tide.
      </div>
    </div>
  `;
  root.querySelector('#start-btn')!.addEventListener('click', onStart);

  // Floating particles
  const canvas = root.querySelector('#title-particles') as HTMLCanvasElement;
  const ctx = canvas.getContext('2d')!;
  let raf = 0;

  function resize() {
    canvas.width = canvas.offsetWidth * devicePixelRatio;
    canvas.height = canvas.offsetHeight * devicePixelRatio;
    ctx.scale(devicePixelRatio, devicePixelRatio);
  }
  resize();

  const particles: { x: number; y: number; vx: number; vy: number; r: number; color: string; alpha: number }[] = [];
  const colors = ['#ffd84d', '#ff6b3d', '#4dd0ff', '#ff5277', '#4dffa8'];
  const w = () => canvas.offsetWidth;
  const h = () => canvas.offsetHeight;

  for (let i = 0; i < 40; i++) {
    particles.push({
      x: Math.random() * w(),
      y: Math.random() * h(),
      vx: (Math.random() - 0.5) * 0.4,
      vy: -Math.random() * 0.3 - 0.1,
      r: Math.random() * 2.5 + 1,
      color: colors[Math.floor(Math.random() * colors.length)],
      alpha: Math.random() * 0.5 + 0.15,
    });
  }

  function draw() {
    ctx.clearRect(0, 0, w(), h());
    for (const p of particles) {
      p.x += p.vx;
      p.y += p.vy;
      if (p.y < -10) { p.y = h() + 10; p.x = Math.random() * w(); }
      if (p.x < -10) p.x = w() + 10;
      if (p.x > w() + 10) p.x = -10;

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = p.color;
      ctx.globalAlpha = p.alpha;
      ctx.fill();

      // Soft glow
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * 4, 0, Math.PI * 2);
      const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
      g.addColorStop(0, p.color);
      g.addColorStop(1, 'transparent');
      ctx.fillStyle = g;
      ctx.globalAlpha = p.alpha * 0.3;
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    raf = requestAnimationFrame(draw);
  }
  draw();

  // Cleanup when leaving title
  const obs = new MutationObserver(() => {
    if (!root.querySelector('#title-particles')) {
      cancelAnimationFrame(raf);
      obs.disconnect();
    }
  });
  obs.observe(root, { childList: true });
}
